import { render, staticRenderFns } from "./2_product_center.vue?vue&type=template&id=7c95b0d6&scoped=true&"
import script from "./2_product_center.vue?vue&type=script&lang=js&"
export * from "./2_product_center.vue?vue&type=script&lang=js&"
import style0 from "./2_product_center.vue?vue&type=style&index=0&id=7c95b0d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c95b0d6",
  null
  
)

export default component.exports